import React, { useState } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Customizedtripslist from "../Components/Customizedtripslist";
import MoCustomizedtripslist from "../Components/MoCustomizedtripslist";
import { API_BASE } from "../api/apiConfig";

const CustomizedTrips = () => {
  const [tripType, setTripType] = useState('international');
  const [selectedCountry, setSelectedCountry] = useState('All Countries');
  const [selectedCity, setSelectedCity] = useState('All Cities');

  const showLocation =
    tripType === 'international'
      ? selectedCountry !== 'All Countries'
      : selectedCity !== 'All Cities';

  const locationName =
    tripType === 'international' ? selectedCountry : selectedCity;

  const tripCount = showLocation ? 1 : 10;

  return (
    <>
      <Header />

      <main className="min-h-screen bg-white">
      <div className='hidden md:block'>
          <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50">
    <div className="absolute inset-0 z-0 opacity-5">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: 'url("../assets/images/travel-pattern-bg.png")',
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      />
    </div>
    <div className="container relative z-10 mx-auto px-4 py-6 md:py-10">
      <div className="grid lg:grid-cols-2 gap-8 items-center max-w-6xl mx-auto">
        <div className="space-y-3">
          <div className="border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-sparkles h-4 w-4"
            >
              <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
              <path d="M5 3v4" />
              <path d="M19 17v4" />
              <path d="M3 5h4" />
              <path d="M17 19h4" />
            </svg>
            Tailored Just For You
          </div>
          <div>
            <h1 className="font-bold text-slate-900 leading-tight text-2xl md:text-3xl lg:text-4xl mb-2">
              Design Your
              <span className="block bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent mt-1">
                Perfect Journey
              </span>
            </h1>
            <p className="text-slate-600 text-sm md:text-base leading-relaxed max-w-lg">
              Let our experts craft a personalized itinerary that matches your
              unique travel style and dreams.
            </p>
          </div>
          <div className="flex flex-wrap gap-4 pt-1">
            <div className="space-y-0.5">
              <p className="text-xl font-bold bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent">
                5000+
              </p>
              <p className="text-xs text-slate-600 font-medium">Custom Trips</p>
            </div>
            <div className="space-y-0.5">
              <p className="text-xl font-bold bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent">
                4.9★
              </p>
              <p className="text-xs text-slate-600 font-medium">
                Average Rating
              </p>
            </div>
            <div className="space-y-0.5">
              <p className="text-xl font-bold bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent">
                98%
              </p>
              <p className="text-xs text-slate-600 font-medium">Satisfaction</p>
            </div>
          </div>
          <div className="relative h-40 rounded-2xl overflow-hidden shadow-2xl hidden md:block">
            <img
              alt="Beautiful travel destination"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                color: "transparent"
              }}
              src="/assets/images/coastal-mountain-vista.png"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          </div>
        </div>
        <div className="lg:pl-8">
          <div className="rounded-lg text-card-foreground shadow-2xl border-0 bg-white/80 backdrop-blur-sm">
            <div className="p-4 md:p-5">
              <div className="mb-4">
                <h2 className="text-lg font-bold text-slate-900 mb-1.5">
                  Start Planning Today
                </h2>
                <p className="text-slate-600 text-xs">
                  Tell us about your dream trip and we'll get back within 24
                  hours
                </p>
              </div>
              <form className="space-y-3">
                <div className="grid md:grid-cols-2 gap-3">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-xs font-semibold text-slate-700 mb-1"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-9 border-slate-200 focus:border-primary text-sm"
                      id="name"
                      placeholder="John Doe"
                      required=""
                      name="name"
                      defaultValue=""
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="contact"
                      className="block text-xs font-semibold text-slate-700 mb-1"
                    >
                      Contact
                    </label>
                    <input
                      type="text"
                      className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-9 border-slate-200 focus:border-primary text-sm"
                      id="contact"
                      placeholder="Email or phone"
                      required=""
                      name="contact"
                      defaultValue=""
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="destination"
                    className="block text-xs font-semibold text-slate-700 mb-1"
                  >
                    Dream Destination
                  </label>
                  <input
                    type="text"
                    className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 h-9 border-slate-200 focus:border-primary text-sm"
                    id="destination"
                    placeholder="e.g., Bali, Switzerland, Japan"
                    required=""
                    name="destination"
                    defaultValue=""
                  />
                </div>
                <div>
                  <label
                    htmlFor="additionalInfo"
                    className="block text-xs font-semibold text-slate-700 mb-1"
                  >
                    Tell Us More
                  </label>
                  <textarea
                    className="flex min-h-[80px] w-full rounded-md border bg-background px-3 py-2 ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-slate-200 focus:border-primary resize-none text-sm"
                    id="additionalInfo"
                    name="additionalInfo"
                    placeholder="Share details about budget, travel dates, number of travelers, interests..."
                    rows={2}
                    defaultValue={""}
                  />
                </div>
                <button
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-md ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 px-4 py-2 w-full h-10 bg-gradient-to-r from-primary to-purple-600 hover:from-primary/90 hover:to-purple-600/90 text-white font-semibold text-sm shadow-lg"
                  type="submit"
                >
                  Get Your Custom Itinerary
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-sparkles ml-2 h-4 w-4"
                  >
                    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                    <path d="M5 3v4" />
                    <path d="M19 17v4" />
                    <path d="M3 5h4" />
                    <path d="M17 19h4" />
                  </svg>
                </button>
                <p className="text-xs text-slate-500 text-center">
                  No commitment required • Free consultation
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="py-12 md:py-16 bg-slate-50">
    <div className="container mx-auto px-4">
      <div className="text-center mb-10">
        <div className="border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 mb-3 inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-clock mr-1 h-4 w-4"
          >
            <circle cx={12} cy={12} r={10} />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          Simple Process
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">
          How It Works
        </h2>
        <p className="text-slate-600 max-w-2xl mx-auto">
          From inquiry to journey in four easy steps
        </p>
      </div>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4 max-w-6xl mx-auto">
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm  border-slate-200 hover:shadow-lg transition-all duration-300 relative overflow-hidden group revealed">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
          <div className="p-5">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-primary/10 to-purple-600/10 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle h-6 w-6 text-primary"
                  >
                    <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm font-bold text-primary/40 mb-1 block">
                  01
                </span>
                <h3 className="text-base font-bold text-slate-900 mb-1.5">
                  Share Your Vision
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Tell us your destination and travel preferences
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm  border-slate-200 hover:shadow-lg transition-all duration-300 relative overflow-hidden group revealed">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
          <div className="p-5">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-primary/10 to-purple-600/10 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-phone h-6 w-6 text-primary"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm font-bold text-primary/40 mb-1 block">
                  02
                </span>
                <h3 className="text-base font-bold text-slate-900 mb-1.5">
                  Expert Consultation
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Our team contacts you within 24 hours
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm  border-slate-200 hover:shadow-lg transition-all duration-300 relative overflow-hidden group revealed">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
          <div className="p-5">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-primary/10 to-purple-600/10 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-plane h-6 w-6 text-primary"
                  >
                    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm font-bold text-primary/40 mb-1 block">
                  03
                </span>
                <h3 className="text-base font-bold text-slate-900 mb-1.5">
                  Custom Itinerary
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Receive your personalized travel plan
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm  border-slate-200 hover:shadow-lg transition-all duration-300 relative overflow-hidden group revealed">
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-purple-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
          <div className="p-5">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-primary/10 to-purple-600/10 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-globe h-6 w-6 text-primary"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                    <path d="M2 12h20" />
                  </svg>
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm font-bold text-primary/40 mb-1 block">
                  04
                </span>
                <h3 className="text-base font-bold text-slate-900 mb-1.5">
                  Enjoy Your Trip
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Travel with confidence and 24/7 support
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>




<Customizedtripslist />



 <section className="relative w-full testimonials-section py-16 bg-slate-50">
                    <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>
                    <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>
                    <div className="container mx-auto px-4 md:px-6">
                        <div className="mb-4 md:mb-6 text-center ">
                            <div className="mb-2 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-sm font-medium text-primary hover-lift">
                                <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"></span>Testimonials
                            </div>
                            <h2 className="mb-2 text-2xl font-bold tracking-tight text-slate-800 sm:text-3xl">What Our <span className="text-gradient">Users</span> Say</h2>
                        </div>
                        <div className="relative -mx-4 px-4 ">
                            <button
                                className="customPrevBtn absolute -left-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-2"
                                aria-label="Previous testimonial"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="lucide lucide-chevron-left h-5 w-5"
                                >
                                    <path d="m15 18-6-6 6-6"></path>
                                </svg>
                            </button>
                            <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-6 scrollbar-hide owl-carousel 3_5owlCarouselstyle" >
                                <div
                                    className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-3 md:p-5 shadow-sm transition-all duration-300 hover-lift hover:border-primary/30 hover:shadow-md"
                                    style={{ transitionDelay: '0ms' }}
                                    data-v0-t="card"
                                >
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20">
                                            <img
                                                alt="Rahul Mehta"
                                                loading="lazy"
                                                decoding="async"
                                                data-nimg="fill"
                                                className="object-cover"
                                                style={{position: 'absolute', height: '100%', width: '100%', inset: '0px', color: 'transparent'}}
                                                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg"
                                            />
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-slate-800">Rahul Mehta</h4>
                                            <p className="text-xs text-primary">Community Member</p>
                                        </div>
                                    </div>
                                    <div className="relative mb-3 rounded-lg bg-slate-50 p-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20"
                                        >
                                            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path>
                                            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path>
                                        </svg>
                                        <p className="pl-2 text-sm italic text-slate-600">Connecting Traveller transformed my trips in India. The local experts helped me discover hidden gems I would have never found on my own. Highly recommended!</p>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-slate-500">Mumbai, India</p>
                                    </div>
                                </div>
                                <div
                                    className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-3 md:p-5 shadow-sm transition-all duration-300 hover-lift hover:border-primary/30 hover:shadow-md"
                                    style={{ transitionDelay: '50ms' }}
                                    data-v0-t="card"
                                >
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20">
                                            <img
                                                alt="Anjali Sharma"
                                                loading="lazy"
                                                decoding="async"
                                                data-nimg="fill"
                                                className="object-cover"
                                                style={{position: 'absolute', height: '100%', width: '100%', inset: '0px', color: 'transparent'}}
                                                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/testimonial-avatar-MOHPr7TbTXzKEubB3Vk3GxIENNM0eG.jpg"
                                            />
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-slate-800">Anjali Sharma</h4>
                                            <p className="text-xs text-primary">Expert User</p>
                                        </div>
                                    </div>
                                    <div className="relative mb-3 rounded-lg bg-slate-50 p-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20"
                                        >
                                            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path>
                                            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path>
                                        </svg>
                                        <p className="pl-2 text-sm italic text-slate-600">The video consultations with local experts were invaluable. They provided authentic insights that no guidebook could offer. My Kerala trip was unforgettable!</p>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-slate-500">Delhi, India</p>
                                    </div>
                                </div>
                                <div
                                    className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-3 md:p-5 shadow-sm transition-all duration-300 hover-lift hover:border-primary/30 hover:shadow-md"
                                    style={{ transitionDelay: '100ms' }}
                                    
                                    data-v0-t="card"
                                >
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20">
                                            <img
                                                alt="Vikram Patel"
                                                loading="lazy"
                                                decoding="async"
                                                data-nimg="fill"
                                                className="object-cover"
                                                style={{position: 'absolute', height: '100%', width: '100%', inset: '0px', color: 'transparent'}}
                                                src="https://v0.blob.com/Yd9Ij.png"
                                            />
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-slate-800">Vikram Patel</h4>
                                            <p className="text-xs text-primary">Travel Expert</p>
                                        </div>
                                    </div>
                                    <div className="relative mb-3 rounded-lg bg-slate-50 p-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20"
                                        >
                                            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path>
                                            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path>
                                        </svg>
                                        <p className="pl-2 text-sm italic text-slate-600">As a travel expert on this platform, I've connected with travelers from across the world. Sharing my knowledge of India has been incredibly rewarding.</p>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-slate-500">Bangalore, India</p>
                                    </div>
                                </div>
                                <div
                                    className="text-card-foreground flex-shrink-0 snap-start overflow-hidden rounded-xl border border-slate-200 bg-white p-3 md:p-5 shadow-sm transition-all duration-300 hover-lift hover:border-primary/30 hover:shadow-md"
                                    style={{ transitionDelay: '150ms' }}
                                    data-v0-t="card"
                                >
                                    <div className="flex items-center gap-3 mb-3">
                                        <div className="relative h-12 w-12 overflow-hidden rounded-full border-2 border-primary/20">
                                            <img
                                                alt="Meera Iyer"
                                                loading="lazy"
                                                decoding="async"
                                                data-nimg="fill"
                                                className="object-cover"
                                                style={{position: 'absolute', height: '100%', width: '100%', inset: '0px', color: 'transparent'}}
                                                src="https://v0.blob.com/Yd9Ij.png"
                                            />
                                        </div>
                                        <div>
                                            <h4 className="font-medium text-slate-800">Meera Iyer</h4>
                                            <p className="text-xs text-primary">Community Member</p>
                                        </div>
                                    </div>
                                    <div className="relative mb-3 rounded-lg bg-slate-50 p-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            className="lucide lucide-quote absolute -left-1 -top-1 h-6 w-6 text-primary/20"
                                        >
                                            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path>
                                            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path>
                                        </svg>
                                        <p className="pl-2 text-sm italic text-slate-600">I was hesitant to join at first, but it's been the best travel decision I've made. The community is supportive and I've made lifelong friends across India.</p>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                className="lucide lucide-star h-4 w-4 fill-primary text-primary"
                                            >
                                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                            </svg>
                                        </div>
                                        <p className="text-xs text-slate-500">Chennai, India</p>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 snap-start overflow-hidden rounded-xl border border-primary/20 bg-gradient-to-br from-primary/10 to-white p-6 flex flex-col items-center justify-center text-center">
                                    <div className="mb-4 rounded-full bg-primary/10 p-3">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            className="lucide lucide-quote h-6 w-6 text-primary"
                                        >
                                            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path>
                                            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path>
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-bold text-slate-800 mb-2">Share Your Experience</h3>
                                    <p className="text-slate-600 mb-4 text-sm">Join thousands of travelers who have found their perfect travel companions</p>
                                    <button
                                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90"
                                    >
                                        Join Now
                                    </button>
                                </div>
                            </div>
                            <button
                                className="customNextBtn absolute -right-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-2"
                                aria-label="Next testimonial"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="lucide lucide-chevron-right h-5 w-5"
                                >
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </section>

<section className="py-16 bg-gradient-to-r from-primary to-primary/90">
  <div className="container mx-auto px-4 text-center">
    <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
      Ready to Plan Your Dream Trip?
    </h2>
    <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
      Get in touch with our travel experts today and start planning an
      unforgettable journey tailored just for you.
    </p>
    <div className="flex flex-wrap gap-4 justify-center">
      <a href="https://wa.me/918920866123" target="_blank" className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 rounded-md px-8 bg-white text-primary hover:bg-white/90">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-phone mr-2 h-5 w-5"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
        Call Us Now
      </a>
      <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-11 rounded-md px-8 border-white text-white hover:bg-white/10 bg-transparent">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-mail mr-2 h-5 w-5"
        >
          <rect width={20} height={16} x={2} y={4} rx={2} />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
        Email Inquiry
      </button>
    </div>
  </div>
</section>

</div>

    
    <MoCustomizedtripslist />

    

      </main>

      <Footer />
    </>
  );
};

export default CustomizedTrips;
